import React from 'react'
import { CSSTransition } from 'react-transition-group'

const Header = ( {onContact, onHome, onExperience} ) => {
    return (
        <CSSTransition in={true} appear={true} timeout={600} classNames="fade">
        <div className='header'>
            <p id='home' className='desktop' onClick={onHome}>Home</p>
            <p id='experience' className='desktop'onClick={onExperience}>Experience</p>    
            <p id='contact' className='desktop' onClick={onContact}>Contact Me</p>
            <p id='home' className='mobile' onClick={onHome}>Home</p>
            <p id='experience' className='mobile' onClick={onExperience} >Experience</p>    
            <p id='contact' className='mobile' onClick={onContact}>Contact Me</p>
        </div>
        </CSSTransition>
    )
}

export default Header
